import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
const apiUrl = process.env.REACT_APP_API_URL;

const Profession = ({
  onNext,
  onVictimProfessionSelected,
  onQuestion,
  answer
  ,apiKey,botToken,vist_id,app_ver
}) => {
  const [Profession, setProfession] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [professionOptions, setProfessionOptions] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false); // State to track audio play status
  
    const audioRef = useRef(null);
 // const vist_id = sessionStorage.getItem("visitor_id");


  useEffect(() => {
    const storedData = localStorage.getItem('Profession');
    if (storedData) {
      setProfession(JSON.parse(storedData));
      onVictimProfessionSelected(JSON.parse(storedData))
    }
  }, []);

  useEffect(() => {
    const fetchProfessionData = async () => {
      try {
        const qulificationResponse = await fetch(
          `${apiUrl}/v1/cy_ma_profesion_list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f65342db514",
              lac_token: botToken,
              "app_ver":app_ver
            }),
          }
        );

        if (!qulificationResponse.ok) {
          throw new Error("Failed to fetch audio options");
        }

        const qulificationData = await qulificationResponse.json();
        //console.log(qulificationData)
        if (qulificationData.resp.error_code === "0") {
          setProfessionOptions(
            qulificationData.resp.profesion_list.map((profession, index) => ({
              id: String.fromCharCode(65 + index),
              value: profession.prof_uniq,
              label: profession.prof_nm,
            })) || []
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchProfessionData();
  }, [apiKey,app_ver,botToken,vist_id]);

  const handleOptionClick = async (option, e) => {
    e.preventDefault();
    setProfession(option.label); // Notify parent component about the selection
    if (option.disabled) {
      return; // Ignore clicks on disabled options
    }
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_choice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f65342db514",
          qtion_num: "7",
          qtion_option: option.id,
          option_val: option.value,
          lac_token: botToken,
          "app_ver":app_ver
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error("Failed to push data to API");
      }

      if(data.resp.error_code ==="0"){
        setProfession(option.label);
        handleOkClick();
        onVictimProfessionSelected(option.label);
        setShowOkButton(true); // Show the OK button after a successful click
        onNext(8);
        onQuestion(9);
        localStorage.setItem('Profession', JSON.stringify(option.label));
        setError("");
      }else{
        setError("Failed to push data to API");
      }
    } catch (err) {
      console.error("Error sending data to API:", err);
    }
  }; 

  const handleOkClick = (e) => {
    if (Profession) {
      onNext(8);
      onQuestion(9);
    } else {
      setError("Please select an option before proceeding.");
      setShowOkButton(false); // Hide the OK button after an unsuccessful attempt
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault()
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause(); // Pause the audio
        setIsPlaying(false);
      } else {
        audioRef.current.play(); // Play the audio
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false); // Reset to show Play button when audio ends
  }; 

  
  return (
    <div className="question">
      <div style={{ display: "flex" }}>
        <div>
        <div style={{ display: "flex" }}>
          <h2>Profession/ Occupation <span style={{ color: "red" }}>*</span></h2>
                    <button
                      onClick={toggleAudio}
                      className="audio-button"
                    >
                   {/* <FaPlay /> */}
                   {isPlaying ? <FaPause /> : <FaPlay />}
                    </button>
                    </div>
                    <audio ref={audioRef} onEnded={handleAudioEnd}>
                      <source src="audio\profession.mp3" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
          <div className="option-list" style={{position :"relative", zIndex:'9'}}>
            {professionOptions.map((option) => (
              <button
                key={option.id} 
                className={`option-button ${
                  Profession === option.label ? "selected" : ""
                }`}
                onClick={(e) => handleOptionClick(option, e)}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor:
                        Profession === option.label
                          ? "#000"
                          : "#fff",
                      color: Profession === option.label ? "#fff" : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label">{option.label}</div>
                </div>
                {Profession === option.label && (
                  <span className="checkmark">
                    &#10003; {/* Unicode character for checkmark */}
                  </span>
                )}
              </button>
            ))}
          </div>

          <div style={{ display: "flex", alignItems: "center",position:'relative', zIndex:"9" }}>
            {showOkButton && (
              <>
                <button
                  type="button"
                  className="ok-btn"
                  onClick={handleOkClick}
                >
                  OK
                </button>
                {/* <p className="enter-text">
                  press <strong>Enter ↵</strong>
                </p> */}
              </>
            )}
            </div>
            {error && <div className="error-message" style={{ position: 'relative', zIndex: '1000' }}>{error}</div>}
            {answer[7] && (
              <p className="alert-box">
                Please answer the current question before moving to the next.
              </p>
            )} 
        </div>
      </div>
    </div>
  );
};

export default Profession;
